require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/fn/array/from.js
// module id = 569
// module chunks = 1